document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook("beforeInstantSearchMainTemplate", function (_defaultTemplate, data, html) {
    /**
     * NOTE: Hide all sections after the Algolia app if search result is successful.
     *
     * The Shopify sections after the Algolia app is only used for "No results".
     *
     * The sections are made visible on the "beforeInstantSearchNoResultTemplate" custom hook
     *  found in: assets/algolia-no-result-template.js
     *
     */
    const mainContent = document.querySelector("#MainContent");
    const algoliaApp = "#algolia-shopify-instantsearch";
    const ignoreSections = [algoliaApp, "#back-to-top"];
    const sections = mainContent.querySelectorAll(".shopify-section");
    let isAfterAIS = false;

    if (sections && window.location.pathname === "/search") {
      sections.forEach((section) => {
        const ignoreElements = ignoreSections.map((cssSelector) => {
          const el = section.querySelector(cssSelector);

          if (el && cssSelector == algoliaApp) {
            isAfterAIS = true;
          }

          if (el) return el;
        });

        if (ignoreElements.filter(Boolean).length) return;

        if (isAfterAIS) {
          section.classList.add("hidden--important");
        }
      });
    }

    function removeSwymAddedClassForGuests() {
      if (isLoggedIn && isLoggedIn !== "false") return;
      const wishlistButtonObserver = new MutationObserver(() => {
        const buttons = document.querySelectorAll("button.swym-add-to-wishlist-view-product.swym-added");
        for (const button of buttons) {
          button.classList.remove("swym-added");
        }
      });
      wishlistButtonObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
      setTimeout(() => wishlistButtonObserver.disconnect(), 500);
    }
    removeSwymAddedClassForGuests();

    document.addEventListener(
      "click",
      function (event) {
        const button = event.target.closest("span.swym-add-to-wishlist-view-product");
        if (!button) return;
        if (!isLoggedIn || isLoggedIn === "false") {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          const loginUrl = getLoginUrl();
          window.location.replace(loginUrl);
        }
      },
      true,
    );

    const urlString = window.location.search;
    const urlParams = new URLSearchParams(urlString);
    const searchQuery = urlParams.get("q");
    const currentUrl = window.location.href;
    const isFollowingPage = currentUrl.includes("following");
    Shopify.analytics.publish("search", {
      url: currentUrl,
      searchQuery,
    });

    const saveSearchButton = html`
      <save-search-button
        id="fp-save-search-button"
        tabindex="0"
        class="fp-plp-button fp-save-search-button"
        aria-label="Save search"
        aria-hidden="true"
        hidden
      >
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
            <path
              d="M7.24989 11.8816L4.30462 9.1344C4.12981 8.9717 3.87004 8.9717 3.69524 9.1344L0.762706 11.8816C0.626963 12.0046 0.437503 12.0349 0.275402 11.9577C0.112315 11.8805 0.00587506 11.7105 0 11.5207V0.494378C0 0.22113 0.207031 0 0.462904 0H7.54297C7.7959 0.00312898 8 0.223196 8 0.494378V11.5218V11.5207C7.99121 11.7064 7.88574 11.8701 7.72755 11.9452C7.57032 12.0214 7.38564 11.9973 7.24989 11.8816Z"
              fill="white"
            />
          </svg>
        </span>
        <span class="fp-save-search-copy">Save Search</span>
      </save-search-button>
    `;

    return html`
      ${window.location.pathname === "/search" &&
      html`<div class="fp-search-result-container">
        <div>
          <p class="caption">Search results for:</p>
          <h2 class="h4">${searchQuery}</h2>
        </div>
      </div>`}
      <div id="fp-ais-shopify-widget" class="ais-page">
        <div id="fp-ais-input" class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div id="fp-filter-wrapper" class="fp-filter-results-wrapper">
          <h4 class="h5">
            Filter
            <span class="fp-ais-facets-count"></span>
          </h4>
          ${isFollowingPage
            ? html`<div class="fp-stats-edit-share-container">
                <div id="fp-ais-item-count" class="ais-stats-container"></div>
                ${isFollowingPage &&
                html`
                  <div
                    class="fp-ais-display-none--desktop fp-following-drawer__trigger-btns--mobile fp-edit-share-btns"
                  >
                    <button aria-label="Edit Following Items" data-follow-edit-btn class="link">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                        <path
                          fill="#191C1F"
                          fill-rule="evenodd"
                          d="M15.655 4.344a2.695 2.695 0 0 0-3.81 0l-.599.599-.009-.009-1.06 1.06.008.01-5.88 5.88a2.75 2.75 0 0 0-.805 1.944v1.922a.75.75 0 0 0 .75.75h1.922a2.75 2.75 0 0 0 1.944-.806l7.54-7.539a2.695 2.695 0 0 0 0-3.81Zm-4.409 2.72-5.88 5.88a1.25 1.25 0 0 0-.366.884v1.172h1.172c.331 0 .65-.132.883-.366l5.88-5.88-1.689-1.69Zm2.75.629.599-.599a1.195 1.195 0 1 0-1.69-1.689l-.598.599 1.69 1.689Z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      <span class="fp-filter-sort">Edit</span>
                    </button>
                    <button aria-label="Share Following Items" data-follow-share-btn class="link">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                        <path
                          fill="#191C1F"
                          fill-rule="evenodd"
                          d="M15.842 4.175a3.746 3.746 0 0 0-5.298 0l-2.116 2.117a3.75 3.75 0 0 0 .01 5.313l.338.336a.75.75 0 1 0 1.057-1.064l-.339-.337a2.25 2.25 0 0 1-.005-3.187l2.116-2.117a2.246 2.246 0 1 1 3.173 3.18l-1.052 1.047a.75.75 0 0 0 1.058 1.064l1.052-1.047a3.746 3.746 0 0 0 .006-5.305Zm-11.664 11.67a3.75 3.75 0 0 0 5.304 0l2.121-2.121a3.75 3.75 0 0 0 0-5.303l-.362-.362a.75.75 0 0 0-1.06 1.06l.362.362a2.25 2.25 0 0 1 0 3.182l-2.122 2.122a2.25 2.25 0 1 1-3.182-3.182l1.07-1.07a.75.75 0 1 0-1.062-1.06l-1.069 1.069a3.75 3.75 0 0 0 0 5.303Z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      <span class="fp-filter-sort">Share</span>
                    </button>
                  </div>
                `}
              </div>`
            : html`
                <div id="fp-ais-item-count" class="ais-stats-container fp-max-width--half"></div>
                ${!isFollowingPage && html`<div class="fp-save-search-button-container">${saveSearchButton}</div>`}
              `}
          <div class="fp-btns-wrapper">
            <div class="fp-share-filter-btns">
              <div class="fp-filter-sort-button">
                <button aria-label="Sorting Options" class="fp-plp-button button--secondary">
                  <span
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="none"
                      class="fp-secondary fp-sm"
                    >
                      <path
                        fill="#191C1F"
                        fill-rule="evenodd"
                        d="M18.75 13.5a3.75 3.75 0 0 1 3.675 3.001h.825a.75.75 0 0 1 .135 1.487L23.25 18l-.825.001a3.751 3.751 0 0 1-7.35 0H.75a.75.75 0 0 1-.135-1.488L.75 16.5l14.325.001c.347-1.712 1.86-3 3.675-3m0 1.5a2.25 2.25 0 0 0-2.25 2.24v.01l-.002.011.012.206a2.25 2.25 0 1 0 2.24-2.466M5.25 3a3.75 3.75 0 0 1 3.675 3.001H23.25a.75.75 0 0 1 .135 1.487l-.135.012-14.325.001a3.751 3.751 0 0 1-7.35 0H.75a.75.75 0 0 1-.135-1.488L.75 6l.825.001c.347-1.712 1.86-3 3.675-3m0 1.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </span>
                  <span class="fp-filter-sort"
                    >Filter<span id="fp-ais-facets-count" class="fp-ais-facets-count"></span
                  ></span>
                  <div class="ais-facets-button">Show filters</div>
                </button>
                <button aria-label="Sorting Options" class="fp-sort-open fp-plp-button button--secondary">
                  <span
                    ><svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.47036 5.08044C7.56035 5.1868 7.56035 5.35999 7.47036 5.46634C7.42536 5.51816 7.36652 5.54543 7.30767 5.54543C7.24883 5.54543 7.18999 5.51816 7.14499 5.46498L5.00024 2.93129V13.7272C5.00024 13.8772 4.89641 13.9999 4.76949 13.9999C4.64258 13.9999 4.53874 13.8772 4.53874 13.7272V2.93129L2.394 5.46498C2.30401 5.57134 2.15748 5.57134 2.06749 5.46498C1.9775 5.35862 1.9775 5.18543 2.06749 5.07908L4.60581 2.07901C4.61619 2.06674 4.62888 2.05447 4.64157 2.04492C4.64734 2.04083 4.65311 2.0381 4.65888 2.03401C4.6658 2.02856 4.67388 2.02447 4.68195 2.02038C4.69003 2.01629 4.69695 2.01492 4.70503 2.0122C4.71195 2.00947 4.71772 2.00674 4.72464 2.00538C4.75464 1.99856 4.78464 1.99856 4.81464 2.00538C4.82156 2.00674 4.82848 2.00947 4.83425 2.0122C4.84232 2.01492 4.84925 2.01765 4.85732 2.02038C4.8654 2.02447 4.87232 2.02992 4.8804 2.03401C4.88617 2.0381 4.89194 2.04083 4.8977 2.04492C4.9104 2.05447 4.92193 2.06674 4.93347 2.07901L7.47036 5.08044ZM13.9313 10.5349C13.8413 10.4286 13.6948 10.4286 13.6048 10.5349L11.4611 13.0686V2.27273C11.4611 2.12273 11.3573 2 11.2304 2C11.1034 2 10.9996 2.12273 10.9996 2.27273V13.0686L8.85487 10.5349C8.76487 10.4286 8.61834 10.4286 8.52836 10.5349C8.43837 10.6413 8.43837 10.8145 8.52836 10.9208L11.0667 13.9209C11.0771 13.9332 11.0897 13.9455 11.1024 13.955C11.1082 13.9591 11.114 13.9618 11.1197 13.9659C11.1267 13.9714 11.1347 13.9755 11.1428 13.9795C11.1509 13.9836 11.1578 13.985 11.1659 13.9877C11.1728 13.9905 11.1786 13.9932 11.1855 13.9945C11.2005 13.9986 11.2155 14 11.2305 14C11.2455 14 11.2605 13.9986 11.2755 13.9945C11.2824 13.9932 11.2893 13.9905 11.2951 13.9877C11.3032 13.985 11.3101 13.9823 11.3182 13.9795C11.3263 13.9755 11.3332 13.97 11.3413 13.9659C11.347 13.9618 11.3528 13.9591 11.3586 13.955C11.3713 13.9455 11.3828 13.9332 11.3943 13.9209L13.9326 10.9208C14.0226 10.8131 14.0226 10.6413 13.9315 10.5349H13.9313Z"
                        fill="black"
                        stroke="black"
                        stroke-width="0.3"
                      />
                    </svg>
                  </span>
                  <span class="fp-filter-sort">Sort</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="fp-filters-modal-container">
          <div class="fp-filters-modal-backdrop"></div>
          <div id="fp-ais-facets" class="ais-facets">
            <div class="fp-filters-heading">
              <h3 class="fp-filters-header h4">Filter</h3>
              <span class="fp-filters-close">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  aria-hidden="true"
                  class="fp-primary fp-xs"
                >
                  <path
                    fill="#191C1F"
                    d="m14.5 12 7.7-7.7 1.6-1.6c.2-.2.2-.6 0-.8L22.1.2c-.2-.2-.6-.2-.8 0L12 9.5 2.7.2c-.2-.2-.6-.2-.8 0L.2 1.9c-.2.2-.2.6 0 .8L9.5 12 .2 21.3c-.2.2-.2.6 0 .8l1.7 1.7c.2.2.6.2.8 0l9.3-9.3 7.7 7.7 1.6 1.6c.2.2.6.2.8 0l1.7-1.7c.2-.2.2-.6 0-.8z"
                  ></path>
                </svg>
              </span>
            </div>
            <div class="fp-refs-clear-filter-wrapper">
              <div
                id="fp-ais-clear-refinements-mobile"
                class="fp-ais-display-none--desktop ais-clear-refinements-container"
              ></div>
              <div
                id="fp-ais-current-refined-values-mobile"
                class="fp-ais-display-none--desktop ais-current-refined-values-container"
              ></div>
            </div>
            <div class="fp-display-and-sort fp-ais-display-none--desktop ais-search-header">
              <div class="hidden ais-change-display">
                <span class="ais-change-display-block ais-change-display-selected"><i class="fa fa-th-large"></i></span>
                <span class="ais-change-display-list"><i class="fa fa-th-list"></i></span>
              </div>
              <div class="ais-sort">
                Sort by
                <span id="fp-algolia-sort-mobile" class="ais-sort-orders-container"></span>
              </div>
            </div>
            <div id="fp-ais-facet-dropdown-container">
              ${data.facets.map(
                (facet, index) =>
                  html`<div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}">
                    <label
                      id="fp-ais-facet-header-${facet.escapedName}"
                      for="${facet.escapedName}"
                      class="ais-facet--header ais-header"
                      >${facet.title}</label
                    >
                    <input
                      aria-labelledby="fp-ais-facet-header-${facet.escapedName}"
                      class="ais-dropdown-checkbox"
                      type="checkbox"
                      id="${facet.escapedName}"
                      name="dropdown"
                      checked="${window.innerWidth < 768 ? "false" : index > 4}"
                    />
                    <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container">
                      ${facet.escapedName.includes("price_filters") && html`<div id="fp-ais-price-range-input"></div>`}
                    </div>
                  </div>`,
              )}
            </div>
            <div class="fp-mobile-filters-footer">
              <button id="fp-clear-filter">Clear Filters</button>
              <button id="fp-see-results">See Results</button>
            </div>
          </div>
        </div>
        <div class="fp-vertical-line"></div>
        <div id="fp-ais-results-container" class="ais-block">
          <div
            id="fp-ais-search-header"
            class="fp-current-refinements-and-sort-container fp-ais-display-none--mobile ais-search-header"
          >
            <div class="hidden ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"><i class="fa fa-th-large"></i></span>
              <span class="ais-change-display-list"><i class="fa fa-th-list"></i></span>
            </div>
            <div class="fp-mobile-sort-background">
              <div class="ais-sort">
                ${isFollowingPage &&
                html`
                  <div class="fp-following-drawer__trigger-btns">
                    <button aria-label="Edit Following Items" data-follow-edit-btn class="link">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                        <path
                          fill-rule="evenodd"
                          d="M15.655 4.344a2.695 2.695 0 0 0-3.81 0l-.599.599-.009-.009-1.06 1.06.008.01-5.88 5.88a2.75 2.75 0 0 0-.805 1.944v1.922a.75.75 0 0 0 .75.75h1.922a2.75 2.75 0 0 0 1.944-.806l7.54-7.539a2.695 2.695 0 0 0 0-3.81Zm-4.409 2.72-5.88 5.88a1.25 1.25 0 0 0-.366.884v1.172h1.172c.331 0 .65-.132.883-.366l5.88-5.88-1.689-1.69Zm2.75.629.599-.599a1.195 1.195 0 1 0-1.69-1.689l-.598.599 1.69 1.689Z"
                        />
                      </svg>
                      Edit
                    </button>
                    <button aria-label="Share Following Items" data-follow-share-btn class="link">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                        <path
                          fill-rule="evenodd"
                          d="M15.842 4.175a3.746 3.746 0 0 0-5.298 0l-2.116 2.117a3.75 3.75 0 0 0 .01 5.313l.338.336a.75.75 0 1 0 1.057-1.064l-.339-.337a2.25 2.25 0 0 1-.005-3.187l2.116-2.117a2.246 2.246 0 1 1 3.173 3.18l-1.052 1.047a.75.75 0 0 0 1.058 1.064l1.052-1.047a3.746 3.746 0 0 0 .006-5.305Zm-11.664 11.67a3.75 3.75 0 0 0 5.304 0l2.121-2.121a3.75 3.75 0 0 0 0-5.303l-.362-.362a.75.75 0 0 0-1.06 1.06l.362.362a2.25 2.25 0 0 1 0 3.182l-2.122 2.122a2.25 2.25 0 1 1-3.182-3.182l1.07-1.07a.75.75 0 1 0-1.062-1.06l-1.069 1.069a3.75 3.75 0 0 0 0 5.303Z"
                        />
                      </svg>
                      Share
                    </button>
                  </div>
                `}
                <span id="fp-mobile-sort-by-copy">Sort by</span>
                <span id="fp-algolia-sort-desktop" class="ais-sort-orders-container"></span>
              </div>
            </div>
            <div class="fp-refinement-group">
              <div
                id="fp-ais-current-refined-values-desktop"
                class="hidden--mobile ais-current-refined-values-container"
              ></div>
              <div id="fp-ais-clear-refinements-desktop" class="hidden--mobile ais-clear-refinements-container"></div>
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div id="fp-ais-pagination" class="ais-pagination-container"></div>
      </div>
    `;
  });
});

document.addEventListener("algolia.instantSearch.onRender", function () {
  document.dispatchEvent(new Event("swym:update-social-count"));

  // Select the pagination container
  const paginationItems = document.querySelectorAll(".ais-Pagination-item");
  const pagination = document.querySelector(".ais-Pagination");
  const currency = window.algoliaShopify.helpers.activeCurrencyCode();
  const currencySymbol = currency === "gbp" ? "£" : "$";

  if (!pagination || paginationItems.length === 0) return;

  // Check if there's only one item (e.g., the current active page)
  const visiblePages = [...paginationItems].filter(
    (item) =>
      !item.classList.contains("ais-Pagination-item--previous") &&
      !item.classList.contains("ais-Pagination-item--next"),
  );

  if (visiblePages.length <= 5) {
    paginationItems.forEach((item) => {
      item.classList.add("ais-pagination--item__disabled");
    });
  } else {
    paginationItems.forEach((item) => {
      item.classList.remove("ais-pagination--item__disabled");
    });
  }

  /**
   * NOTE: query the secondary images used in assets/injected-product-card.js once they render
   */
  document.querySelectorAll(".fp-injected-secondary-image").forEach(async (img) => {
    const handle = img.dataset.productHandle;
    const imgSrc = img.getAttribute("src");

    if (!imgSrc.includes("-placeholder-")) return;
    if (!handle) return;

    const secondaryImage = await getSecondaryImageByHandle(handle);
    if (secondaryImage) {
      img.src = secondaryImage;
    }
  });

  document.querySelectorAll(".ais-CurrentRefinements-categoryLabel").forEach((el) => {
    const text = el.textContent.trim();
    const hasGTE = text.includes("≥");
    const hasLTE = text.includes("≤");
    if (hasGTE || hasLTE) {
      // If text already contains a dollar sign with a number, format it properly
      if (text.includes(currencySymbol)) {
        const match = text.match(/\$?\s*(\d+)/);
        if (match) {
          const symbol = text.trim().charAt(0);
          const number = match[1];
          el.textContent = `${symbol} ${currencySymbol}${number}`;
        }
        return;
      }
      const match = text.match(/^(\D*)\s*(\d+)/);
      if (match) {
        const symbol = match[1].trim();
        const number = match[2];
        el.textContent = `${symbol} ${currencySymbol}${number}`;
      }
    } else {
      return;
    }
  });
});

// Function to update the count in the DOM
function updateRefinedCount() {
  const container = document.querySelector("#fp-ais-current-refined-values-mobile");
  if (!container) return;
  const appliedFiltersCount = container.querySelectorAll(".ais-CurrentRefinements-categoryLabel").length;
  const countElements = document.getElementsByClassName("fp-ais-facets-count");
  if (countElements?.length) {
    for (let i = 0; i < countElements.length; i++) {
      countElements[i].textContent = appliedFiltersCount > 0 ? ` (${appliedFiltersCount})` : "";
    }
  }
}

function handleContainerReady(container) {
  const refinedCountObserver = new MutationObserver(() => {
    if (!document.body.contains(container)) {
      refinedCountObserver.disconnect();
      return;
    }
    updateRefinedCount();
  });

  refinedCountObserver.observe(container, {
    childList: true,
    subtree: true,
  });

  updateRefinedCount();
}

// callback function to handle mobile filter and sort
function handleAlgoliaReady(container) {
  if (!container) {
    return;
  }
  const utilityBar = document.querySelector(".utility-bar");
  const filtersAndSortModal = container.querySelector(".fp-filters-modal-container");
  const filtersAndSortBackdrop = container.querySelector(".fp-filters-modal-backdrop");
  const aisFiltersContainer = container.querySelector("#fp-ais-facets");
  const mobileFiltersClose = container.querySelector(".fp-filters-close");
  const mobileSortClose = container.querySelector(".fp-sort-close");
  const sortByDropdown = container.querySelector(".fp-display-and-sort");
  const clearFilterFooterBtn = container.querySelector("#fp-clear-filter");
  const seeResultsFooterBtn = container.querySelector("#fp-see-results");
  const filterAndSortButtonWrapper = container.querySelector(".fp-filter-results-wrapper");
  const filterButtonWrapper = filterAndSortButtonWrapper.querySelector(".fp-share-filter-btns");
  const filtersToggleBtn = filterButtonWrapper.querySelector(".ais-facets-button");
  const sortToggleBtn = filterButtonWrapper.querySelector(".fp-sort-open");
  const aisResultsContainer = container.querySelector("#fp-ais-results-container");
  const aisSearchHeader = aisResultsContainer.querySelector("#fp-ais-search-header");

  sortToggleBtn.addEventListener("click", () => {
    document.body.classList.toggle("fp-mobile-filters-styles");
    utilityBar.classList.toggle("fp-mobile-filters-styles");
    filtersAndSortModal.classList.toggle("fp-mobile-filters-styles");
    filtersAndSortBackdrop.classList.toggle("fp-mobile-filters-styles");
    aisSearchHeader.classList.toggle("fp-mobile-filters-styles");
  });

  mobileSortClose.addEventListener("click", () => {
    sortToggleBtn.click();
  });

  mobileFiltersClose.addEventListener("click", () => {
    filtersToggleBtn.click();
  });

  filtersToggleBtn.addEventListener("click", () => {
    document.body.classList.toggle("fp-mobile-filters-styles");
    utilityBar.classList.toggle("fp-mobile-filters-styles");
    filtersAndSortModal.classList.toggle("fp-mobile-filters-styles");
    filtersAndSortBackdrop.classList.toggle("fp-mobile-filters-styles");
    aisFiltersContainer.classList.toggle("fp-mobile-filters-styles");
    sortByDropdown.classList.toggle("fp-mobile-filters-styles");
  });

  clearFilterFooterBtn.addEventListener("click", () => {
    const helper = window.algoliaShopify.instantsearch.search.helper;
    helper.clearRefinements();
    helper.search();
  });

  seeResultsFooterBtn.addEventListener("click", () => {
    filtersToggleBtn.click();
  });
}

// callback function to toggle filters dropdown for accessibility
function handleFilterDropdownReady(container) {
  if (!container) return;

  const headerCheckboxes = document.querySelectorAll(".ais-dropdown-checkbox");
  const facetValuesCheckboxes = document.querySelectorAll(".ais-RefinementList-checkbox");
  const checkboxes = [...headerCheckboxes, ...facetValuesCheckboxes];

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener("keydown", (event) => {
      const labelNode = event.target.parentNode?.querySelector("label");
      if (labelNode && event.key === "Enter") {
        labelNode.click();
      }
    });
  });
}

waitForElement("#fp-ais-current-refined-values-mobile", handleContainerReady, 3000);

waitForElement("#fp-ais-shopify-widget", handleAlgoliaReady);

waitForElement(".ais-dropdown-checkbox", handleFilterDropdownReady);
